import { __decorate } from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import colors from '@/styles/color.scss';
import taskTypeMessages from '@blade-sxp/task-management/lang/task-type';
import moment from 'moment';
let default_1 = class default_1 extends Vue {
    tagIndex;
    pageSize;
    imgList;
    isCheck;
    colors = colors;
    get privacyMode() {
        return localStorage.getItem('privacyMode') || 'false';
    }
    getValue(val) {
        let value;
        if (val.incidentType === 'FACE_MATCH' || val.incidentType === 'INCIDENT_FACE_UNMATCHED') {
            value = val?.faceAnnotation?.value;
        }
        else if (val.incidentType === 'FACE_PEDESTRIAN') {
            value = val?.pedestrianAnnotation?.value;
        }
        return `${(value * 100).toFixed(2)}%`;
    }
    getPortraitCaptureImage(val) {
        let value = '';
        if (val.incidentType === 'FACE_MATCH' || val.incidentType === 'INCIDENT_FACE_UNMATCHED') {
            value = val?.faceAnnotation?.portraitCaptureImage;
        }
        else if (val.incidentType === 'FACE_PEDESTRIAN') {
            value = val?.pedestrianAnnotation?.portraitCaptureImage;
        }
        return value;
    }
    getPortraitImage(val) {
        let value = '';
        if (val.incidentType === 'FACE_MATCH' || val.incidentType === 'INCIDENT_FACE_UNMATCHED') {
            value = val?.faceAnnotation?.portraitImage;
        }
        else if (val.incidentType === 'FACE_PEDESTRIAN') {
            value = val?.pedestrianAnnotation?.portraitImage;
        }
        return value;
    }
    getPanoramicImage(val) {
        let value = '';
        if (val.incidentType === 'INCIDENT_FACE_UNMATCHED') {
            value = val?.faceAnnotation?.portraitCaptureImage;
        }
        else if (val.incidentType === 'FACE_MATCH') {
            value = val?.faceAnnotation?.panoramicImage;
        }
        else if (val.incidentType === 'FACE_PEDESTRIAN') {
            value = val?.pedestrianAnnotation?.portraitCaptureImage;
        }
        return value;
    }
    getPortraitName(val) {
        let value = '';
        if (val.incidentType === 'FACE_MATCH' || val.incidentType === 'INCIDENT_FACE_UNMATCHED') {
            value = val?.faceAnnotation?.portraitName;
        }
        else if (val.incidentType === 'FACE_PEDESTRIAN') {
            value = val?.pedestrianAnnotation?.portraitName;
        }
        return value;
    }
    getLibraryName(val) {
        let value = '';
        if (val.incidentType === 'FACE_MATCH' || val.incidentType === 'INCIDENT_FACE_UNMATCHED') {
            value = val?.faceAnnotation?.libraryName;
        }
        else if (val.incidentType === 'FACE_PEDESTRIAN') {
            value = val?.pedestrianAnnotation?.libraryName;
        }
        return value;
    }
    getDeviceName(val) {
        return val?.deviceName || '';
    }
    getAlertTime(val) {
        const value = val?.alertTime;
        return moment(Number(value)).format('YYYY-MM-DD HH:mm:ss') || '';
    }
    openDetail(data, index) {
        this.$emit('open-detail', data, index);
    }
    changeChecked(val, deviceVal, index) {
        this.$emit('change-track', val, deviceVal, index);
    }
    getTitle(type) {
        let title = '';
        if (type === 'CRITICAL') {
            title = `${this.$t('critical')}`;
        }
        else if (type === 'MAJOR') {
            title = `${this.$t('major')}`;
        }
        else {
            title = `${this.$t('minor')}`;
        }
        return title;
    }
    getStyle(type) {
        let style = '';
        switch (type) {
            case 'CRITICAL':
                style = `background:${colors.backgrounCritical};color:${colors.textCritica}`;
                break;
            case 'MAJOR':
                style = `background:${colors.backgroundMajor};color:${colors.textMajor}`;
                break;
            default:
                style = `background:${colors.boardLevelMinorBj};color:${colors.vaDotGreenText}`;
        }
        return style;
    }
    getCheckedStyle(checked) {
        let style = '';
        switch (checked) {
            case true:
                style = `background:${colors.arrowBg}`;
                break;
            default:
                style = '';
        }
        return style;
    }
};
__decorate([
    Prop({ default: 0, type: Number })
], default_1.prototype, "tagIndex", void 0);
__decorate([
    Prop()
], default_1.prototype, "pageSize", void 0);
__decorate([
    Prop()
], default_1.prototype, "imgList", void 0);
__decorate([
    Prop()
], default_1.prototype, "isCheck", void 0);
default_1 = __decorate([
    Component({
        name: 'task-result',
        components: {
            'blur-picture': BlurPicture,
        },
        i18n: {
            messages: taskTypeMessages,
        },
    })
], default_1);
export default default_1;
